export default {
  name: "LoadingBuff"
};